export class UserLogin {
  id: string;
  username: string;
}
